import { mobileLargeMax, tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { Heading, SubHeading, Text } from '../typography';

export const WhyHeading = styled(Heading)<{ why?: boolean }>`
  @media (${tabletMax}) {
    ${({ why }) =>
      !why
        ? css`
            margin-bottom: 40px;
          `
        : ''}
    font-size: 30px;
  }
`;

export const WhySubHeading = styled(SubHeading)<{ why?: boolean }>`
  color: ${({ theme }) => theme.backgroundMid};
  @media (${tabletMax}) {
    ${({ why }) =>
      why
        ? css`
            margin-bottom: 30px;
          `
        : ''}
    font-size: 18px;
  }
`;

export const WhyText = styled(Text)`
  @media (${tabletMax}) {
    margin-bottom: 60px;
    font-size: 20px;
  }

  @media (${mobileLargeMax}) {
    font-size: 18px;
  }
`;
